import React from "react";
import { ILS_CONSTS, NEBRASKA_CONSTS } from "../../../Utils/StaticData/Constant";
import NeBraskaPremiums from "./NeBraskaPremiums"
/*this component is build for customer specific premium types.
So far existing premium types are common but for braska first time there is extra premium type came
so separating for code maintainability.
*/



const customerPremiums=(customerId)=>{
  let premium_C;
  switch(customerId.trim()){
    case NEBRASKA_CONSTS.ID:
    case ILS_CONSTS.ID:{
      premium_C=NeBraskaPremiums;
      break;
    }
    default:{
      premium_C=null;
      break;
    }
  }

  return premium_C;
}
const PremiumType = ({ handleChange, customerId, data, isPreview }) => {
  const premium_Component=customerPremiums(customerId);
  if(premium_Component!==null){
  return premium_Component(isPreview, data, handleChange,customerId)
  }
  else{
    return null
  }
};
export default PremiumType;
